// Los valores con los que «Acciones» abre «Nueva oportunidad» (07_MODULOS/FERIAS/M6_ACCIONES.md §3.2,
// D-FE-41, D-FE-42, D-FE-22, P5). Todo sigue siendo editable en la ventana.
import type { AccionesCaso, TipoOportunidad, ValorCampo } from '../../api/feriasApi';
import type { Catalogos } from '../../api/oportunidadesApi';
import type { InicialesOportunidad } from '../Oportunidades/Modales';
import { MAXIMO_OBSERVACIONES_VENTA } from '../Oportunidades/reglas';

/** Ids de los catálogos de Gescom (M6 §3.2): iniciativa Cliente, origen Ferias y eventos, forma de contacto Stand feria, operación Venta y Gestión. */
export const INICIATIVA_CLIENTE = 452;
export const ORIGEN_FERIAS = 7;
export const FORMA_CONTACTO_STAND = 536;
export const OPERACION_VENTA = 525;
export const OPERACION_GESTION = 527;

/** Las observaciones de una oportunidad de compra admiten hasta 20 000 caracteres; las de venta, 500. */
export const MAXIMO_OBSERVACIONES_COMPRA = 20000;

// La primera línea de las observaciones (D-FE-22).
const ENCABEZADO = 'Reunión stand feria.';

/**
 * Las observaciones de la oportunidad: «Reunión stand feria.», un salto de línea y las Observaciones de la
 * ficha (D-FE-22), recortadas al máximo del tipo.
 */
export function observacionesDe(valores: Record<string, ValorCampo> | null, maximo: number): string {
  const ficha = typeof valores?.observaciones === 'string' ? valores.observaciones.trim() : '';
  const texto = ficha === '' ? ENCABEZADO : `${ENCABEZADO}\n${ficha}`;
  return texto.slice(0, maximo);
}

/** El tipo de operación de la venta: Gestión si la ficha marca *gestión* (también con *venta*, P5); si no, Venta. */
export function operacionDe(valores: Record<string, ValorCampo> | null, catalogos: Catalogos): number {
  const marcadas = Array.isArray(valores?.tratamiento) ? (valores?.tratamiento as string[]) : [];
  return marcadas.includes('gestion') ? catalogos.idTipoOperacionGestion ?? OPERACION_GESTION : OPERACION_VENTA;
}

/**
 * Los valores iniciales de la ventana para un tipo: el cliente del caso (titular en la venta), la iniciativa
 * Cliente, el origen y el detalle de la feria (sin detalle si la feria no lo tiene, D-FE-42), la forma de
 * contacto Stand feria en la venta y las observaciones. Sin responsable: nace sin él (D-FE-23).
 */
export function inicialesDe(
  tipo: TipoOportunidad,
  caso: AccionesCaso,
  valores: Record<string, ValorCampo> | null,
  catalogos: Catalogos,
): InicialesOportunidad {
  const idCliente = caso.idCliente as number;
  const cliente = { value: idCliente, label: caso.nombreCliente ?? `Cliente ${idCliente}`, detalle: caso.codigoCliente ?? undefined };
  const origen = {
    idIniciativa: INICIATIVA_CLIENTE,
    idOrigen: caso.idOrigenFeria ?? ORIGEN_FERIAS,
    ...(caso.idDetalleOrigenFeria !== null ? { idDetalle: caso.idDetalleOrigenFeria } : {}),
  };
  if (tipo === 'venta') {
    return {
      valores: {
        idsTitulares: [idCliente],
        idTipoOperacion: operacionDe(valores, catalogos),
        ...origen,
        idFormaContacto: FORMA_CONTACTO_STAND,
        observaciones: observacionesDe(valores, MAXIMO_OBSERVACIONES_VENTA),
      },
      titulares: [cliente],
    };
  }
  return {
    valores: { idCliente, ...origen, observaciones: observacionesDe(valores, MAXIMO_OBSERVACIONES_COMPRA) },
    cliente,
  };
}
